import {
  DestroyRef,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  inject
} from '@angular/core';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import {OrganisationService} from "./organisation.service";
import {AuthenticationService} from "../authentication/authentication.service";
import {EMPTY, switchMap} from 'rxjs';
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatSelect} from "@angular/material/select";
import {ToolbarIconButtonComponent} from "../comps/toolbar-icon-button/toolbar-icon-button.component";
import {MatExpansionPanel} from "@angular/material/expansion";
import {MatChipListbox} from "@angular/material/chips";
import {UploadFileComponent} from "../comps/upload-file/upload-file.component";
import {Organisation} from "../models/server/Organisation";

@Directive({
    selector: '[activeorg]',
    standalone: true
  })
  export class OrgNotDeactivatedDirective implements OnChanges {


  // default disabled value
  @Input()
  disable: boolean = false;

  private org: Organisation | null = null;

  private orgService = inject(OrganisationService);
  private authService = inject(AuthenticationService);
  private destroyRef = inject(DestroyRef);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly input = inject(HTMLInputElement as any, { optional: true, self: true }) as HTMLInputElement;
  private readonly button = inject(MatButton, { optional: true, self: true });
  private readonly appToolbarButton = inject(ToolbarIconButtonComponent, { optional: true, self: true });
  private readonly upload = inject(UploadFileComponent, { optional: true, self: true });
  private readonly iconButton = inject(MatIconButton, { optional: true, self: true });
  private readonly expPanel = inject(MatExpansionPanel, { optional: true, self: true });
  private readonly chipListbox = inject(MatChipListbox, { optional: true, self: true });
  private readonly select = inject(MatSelect, { optional: true, self: true });

  constructor() {
    toObservable(this.authService.isAuthenticated)
      .pipe(
        switchMap(isAuthenticated => {
          if (!isAuthenticated) {
            this.org = null;
            this.update();
            return EMPTY;
          }

          return this.orgService.getOrganisation();
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(org => {
        this.org = org;
        this.update();
      });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['disable'] && !changes['disable'].firstChange) {
      this.update();
    }
  }

  private update(): void {
    if (this.org) {
      let dis = this.org.isTrialExpired || this.org.isDeactivated || this.disable;

      if (this.button) {
        this.button.disabled = dis;
      } else if (this.iconButton) {
        this.iconButton.disabled = dis;
      } else if (this.select) {
        this.select.disabled = dis;
      } else if (this.appToolbarButton) {
        this.appToolbarButton.disabled = dis;
      } else if (this.upload) {
        this.upload.disabled = dis;
      } else if (this.expPanel) {
        this.expPanel.disabled = dis;
      } else if (this.chipListbox) {
        this.chipListbox.disabled = dis;
      } else if (this.input) {
        this.input.disabled = dis;
      } else if (
        this.elementRef.nativeElement &&
        "disabled" in this.elementRef.nativeElement
      ) {
        this.elementRef.nativeElement.disabled = dis;
      }
    }
  }
}
